import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../../Layout/Topo';
import Overlay from '../../Miscelania/Overlay';

import Select from 'react-select';
import InputMask from 'react-input-mask';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../../i18n/getLocale';

class FlightReportsPontuality extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
      fuel_company_select: [],
      totals: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.search = this.search.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeMultiple(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            aircrafts_select: responseJson.data.aircrafts_select,
            aircraft_models_select: responseJson.data.aircraft_models_select,
            bases_select: responseJson.data.bases_select,
            flight_types_select: responseJson.data.flight_types_select,
            clients_select: responseJson.data.clients_select,
            receits_select: responseJson.data.receits_select,
            fuel_company_select: responseJson.data.fuel_company_select,
            staffs_select: responseJson.data.staffs_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  search(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      aircraft_id: this.state.aircraft_id,
      base_id: this.state.base_id,
      contract_id: this.state.contract_id,
      flight_type_id: this.state.flight_type_id,
      flight_report_id: this.state.flight_report_id,
      status: this.state.status,
      aircraft_model_id: this.state.aircraft_model_id,
      receit: this.state.receit,
      fuel_company: this.state.fuel_company,
      status: this.state.status,
      type: this.state.type,
    };

    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios/pontualidade', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({totals: responseJson.data.main, headers: responseJson.data.headers, searched: 1});
          self.handleAlert('', '', 'closed');
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    var columns = null

    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.titulo}</h3>
      <hr/>

      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.formulario.DataInicial}:</label>
            <InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" required />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.formulario.DataFinal}:</label>
            <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" required />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.formulario.Base}:</label>
            <Select
              className=""
              name="base_id"
              value={this.state.base_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'base_id')}
              options={this.state.bases_select}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.formulario.SomenteAprovados}:</label>
            <Select
              className=""
              name="status"
              value={this.state.status}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'status')}
              options={[
                {value: 1, label: this.locale.general.sim},
                {value: 0, label: this.locale.general.nao},
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.formulario.TipoDeAtraso}:</label>
            <Select
              className=""
              name="type"
              value={this.state.type}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'type')}
              options={[
                {value: "departure", label: this.locale.RelatoriosDeVoo.RelatorioDePontualidade.formulario.opcoesTiposDeAtraso.Decolagem},
                {value: "flight", label: this.locale.RelatoriosDeVoo.RelatorioDePontualidade.formulario.opcoesTiposDeAtraso.TempoDeVoo},
              ]}
            />
          </div>
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-search"></i> {this.locale.general.pesquisar}</button>
      </form>
      {self.state.searched === 1 &&
        <div>
          <br/>
          <table className="table table-bordered table-striped table-hover">
            <thead>
              <tr>
                <th className="table-totals-flights-style" colSpan="2">{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.EstatisticasDeVooDe(this.state.date_start, this.state.date_finish)}</th>
              </tr>
              <tr>
                <th>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Tipo}</th>
                <th>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Valor}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.TempoTotalDeAtraso}</td>
                <td>{this.state.totals ? this.state.totals['atraso_total'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Atrasados}</td>
                <td>{this.state.totals ? this.state.totals['atraso_qtd'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Pontuais}</td>
                <td>{this.state.totals ? this.state.totals['pontual_qtd'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.MediaTempo}</td>
                <td>{this.state.totals ? this.state.totals['atraso_media'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Operacoes}</td>
                <td>{this.state.totals ? this.state.totals['operacoes'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Coordenacao}</td>
                <td>{this.state.totals ? this.state.totals['coordenacao'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Despacho}</td>
                <td>{this.state.totals ? this.state.totals['despacho'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Manutencao}</td>
                <td>{this.state.totals ? this.state.totals['manutencao'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.NumeroVoos}</td>
                <td>{this.state.totals ? this.state.totals['voo_total'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.AtrasadosInterno}</td>
                <td>{this.state.totals ? this.state.totals['atraso_interno'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.AtrasadosExterno}</td>
                <td>{this.state.totals ? this.state.totals['atraso_externo'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Pontualidade}</td>
                <td>{this.state.totals ? this.state.totals['pontualidade_total'] : 0}%</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.PontualidadeSemAtrasoExterno}</td>
                <td>{this.state.totals ? this.state.totals['pontualidade_ext'] : 0}%</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.PontualidadeSemAtrasoInterno}</td>
                <td>{this.state.totals ? this.state.totals['pontualidade_int'] : 0}%</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.VooManutencao}</td>
                <td>{this.state.totals ? this.state.totals['mnt'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.VooGiros}</td>
                <td>{this.state.totals ? this.state.totals['giros'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.VooTreinamento}</td>
                <td>{this.state.totals ? this.state.totals['treinamento'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.VooPTBR}</td>
                <td>{this.state.totals ? this.state.totals['ptbr'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.VooOutrosClientes}</td>
                <td>{this.state.totals ? this.state.totals['clientes'] : 0}</td>
              </tr>
              <tr>
                <td>{this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.VoosComerciais}</td>
                <td>{this.state.totals ? this.state.totals['comerciais'] : 0}</td>
              </tr>
            </tbody>
          </table>
        </div>
      }
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportsPontuality;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Control/FlightReportsPontuality.js